import { Button, Grid, DropdownButton, Dropdown, DropdownItem, DropdownMenu} from "@deere/fuel-react";
import { useOktaAuth } from '@okta/okta-react';
import 'flag-icon-css/css/flag-icons.min.css';
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useUserInfo } from '../../providers/userProvider';
import { getCOOResponsesByAssignment } from '../../services/coo.service';
import { handleSaveCooAnswers } from '../../utils/saveSurveyUtils';
import { useHistory} from 'react-router';
import { DEFAULT_LANGUAGE, SCBM_USER_TYPE } from '../../utils/surveyLiterals';
import { getSectionsWithErrors, validateDates, validatePartsAndSuppForCOO } from '../../utils/validation';
import { getSuppSurveyConfiguration } from "../../services/userService";
import { getSurveyLiterals } from "../../services/survey.service";
import i18next from "i18next";
import Cookies from "js-cookie";
import { getSurveyLanguages } from "../../utils/utils";

export const CooButtonsSection = React.forwardRef(({ campaign, clearFunction, survey, setSurvey, setLiterals, setErrorCard, setSuccessMessage, setCOOResponseSelected, cooResponseSelected, setIsSubmitted, errorCard, setValidated, sections, cooForm, setCOOResponses, cooData, resetForm, disabled }) => {
    const history = useHistory();
    const { authState } = useOktaAuth();
    const { t } = useTranslation();
    const suppliers = cooData.suppliers
    const parts = cooData.parts;
    const answers = cooData.answers;
    const userInfo = useUserInfo();
    const [disableSubmit, setDisableSubmit] = useState(userInfo.userType === SCBM_USER_TYPE.SALARY);
    const [currentLanguageCode, setCurrentLanguageCode] = useState(Cookies.get('i18next') || DEFAULT_LANGUAGE);
    const LANGUAGES = getSurveyLanguages(survey.code);

    function review(responseId){
        history.push({
            pathname: '/coo/review',
            state: {
                previous: '/coo',
                assignmentId: campaign.assignments[0].id,
                responseId: responseId,
                survey: survey,
                cooData:cooData
            }
        })
    }

    const handleSubmit = (e) => {
        clearFunction();
        setIsSubmitted(true)
        let errorSections = getSectionsWithErrors(cooForm);
        setErrorCard(errorSections);
        validatePartsAndSuppForCOO(Array.isArray(suppliers) ? suppliers : [], Array.isArray(parts) ? parts : [], errorSections, sections);
        setErrorCard(errorSections);

        validateDates(sections, answers, errorSections, cooForm);
        setErrorCard(errorSections);

        if (errorCard && errorCard.length > 0) {
            e.preventDefault();
            e.stopPropagation();
        }

        setValidated(true);
        e.preventDefault();
        e.stopPropagation();

        if (cooForm.checkValidity() && errorSections.length <= 0) {
            setIsSubmitted(false);
            setValidated(false);
            handleSaveCooAnswers(authState, cooData, campaign, cooData.id).then(resp => {
                if (resp && resp.id) {
                    setCOOResponseSelected(resp);
                    review(resp.id);
                } else {
                    setErrorCard([t('lbl_error_saving_message')]);
                }

            }).catch(err => {
                console.log(err);
                setErrorCard([t('lbl_error_saving_message')]);
            });


        }

        window.scrollTo(0, 0);

    }

    const changeLanguage = locale => {
        // Get Translated section & question details
        getSuppSurveyConfiguration(campaign.surveyId, locale, authState.accessToken.accessToken)
                .then((s) => {                
                    setSurvey(s);
        });
    
        //Get Translated Literal values
        getSurveyLiterals(campaign.surveyId, locale, authState.accessToken.accessToken).then((response) => {
          let arrLiterals = [];
          response.forEach((res)=>{
            let index = arrLiterals.findIndex(item => item.code === res.code);
            if(index === -1){
              let literal = response.find(item => item.code === res.code && item.languageCd === locale);
              if(!literal) literal = response.find(item => item.code === res.code && item.languageCd === DEFAULT_LANGUAGE);
              arrLiterals.push(literal);
            }
          });
          setLiterals(arrLiterals);
        });

        i18next.changeLanguage(locale);
        setCurrentLanguageCode(locale);
    }

    const handleSave = (e) => {
        if(!cooData.responseName || !cooData.responseName.trim()){
            setErrorCard([t('lbl_error_response_name')]);
            setDisableSubmit(false);
            window.scrollTo(0, 0);
        }else{
            setDisableSubmit(true);
            e.preventDefault();
            clearFunction();
            handleSaveCooAnswers(authState, cooData, campaign, cooData.id ).then(resp => {
                if (resp && resp.id) {
                    resetForm();
                    getCOOResponsesByAssignment(campaign.assignments[0].id, authState.accessToken.accessToken).then(response => {
                        if (response) {
                            setCOOResponses(response);
                        }
                    });
                    setCOOResponseSelected(resp);
                    setSuccessMessage(t('lbl_success_save_message'));
                    setDisableSubmit(false);
                    window.scrollTo(0, 0);
                } else {
                    setErrorCard([t('lbl_error_saving_message')]);
                    setDisableSubmit(false);
                    window.scrollTo(0, 0);
                }
            }).catch(err => {
                console.log(err);
                setErrorCard([t('lbl_error_saving_message')]);
                setDisableSubmit(false);
                window.scrollTo(0, 0);
            });
            window.scrollTo(0, 0);
            setDisableSubmit(false);    
        }
    }

    return (
        <Grid container className="card position-sticky fixed-bottom">
        <Grid className="card-body p-3 text-right" justifyContent="space-between">
          <span className='mr-2' variant="secondary">
            <Dropdown size="small">
              <DropdownButton onClick={e => e.preventDefault()}>{t('btn_change_language')} </DropdownButton>
              <DropdownMenu placement="top-start">
                {LANGUAGES.map(({ code, name, country_code }) => (
                      currentLanguageCode === code ? <DropdownItem key={country_code}
                          href="#" className="nav-link active" onClick={e => e.preventDefault()}>
                          <span className={`flag-icon flag-icon-${country_code} mx-2`} style={{ opacity: 0.3 }}></span>{name}
                      </DropdownItem> : <DropdownItem key={country_code}
                          href="#" onClick={() => changeLanguage(code)}>
                          <span className={`flag-icon flag-icon-${country_code} mx-2`} style={{ opacity: 1 }}></span>{name}
                      </DropdownItem>
                  ))}
              </DropdownMenu>
            </Dropdown>
          </span>
          <Button className='mr-2' variant="secondary" onClick={handleSave} disabled={disableSubmit || disabled}>{t('btn_save_survey')}</Button>
          <Button className='mr-2' variant="primary" type='submit' onClick={handleSubmit} disabled={disableSubmit || disabled}>{t('btn_review')}</Button>
        </Grid>
            
        </Grid>
    )
})
